import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '*',
        redirect: '/invite'
    },
    {
        path: '/invite/:from/:id',
        name: 'invite',
        component: () => import('./view/invite'),
        meta: {
            // title: '邀请你加入OK赚!'
        }
    }

];

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
    mode: 'history',
    base: '/',
    routes
});

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        // document.title = title;  // 需要加上用户昵称，所以在代码里面实现
    }
    next();
});

export {
    router
};
